'use client';

import { Quote } from "lucide-react";

const PARTNER_TESTIMONIALS = [
  {
    id: 1,
    name: "Mr. Vishal Kulkarni",
    role: "Asst. Vice President, Skill Development Division",
    company: "AEQUS",
    image: "/images/partners/vishal-kulkarni.jpg",
    quote:
      "AEQUS is one of the largest precision manufacturing industries, holding expertise in aerospace, toys, and consumer durables. We saw certain gaps when an apprentice joins any organization. So, we collaborated with MSU and got introduced to the Apprenticeship Embedded Degree Program under their WISE initiative. It’s a great tool to groom required skills in manpower resources.",
  },
  {
    id: 2,
    name: "Mr. Amrit Choudhary",
    role: "Managing Director",
    company: "UHR",
    image: "/images/partners/amrit-choudhary.jpg",
    quote:
      "We’ve collaborated with Medhavi Skills University under the WISE Program to offer trainees Flexi-MOU, D.Voc, and B.Voc courses. MSU is completing their 100% compliance regarding these educational schemes where students get the opportunity to learn and earn at the industry premises, achieving education and career growth at the same time.",
  },
  {
    id: 3,
    name: "Mr. Sarvan Kr. Yadav",
    role: "HR Organizer",
    company: "IHG Hotels & Resorts",
    image: "/images/partners/sarvan-yadav.jpg",
    quote:
      "Being HR manager in the IHG group, I really appreciate all the Medhavi students. They are learning skills and their potential is a real benefit for IHG and other hotels. Thanks to Medhavi University, they are providing better students to us who help in all areas of hospitality.",
  },
];

export function PartnerTestimonialsSection() {
  return (
    <section className="relative bg-[#e9f4ff] py-12 md:py-16 lg:py-20">
      <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto">
        {/* Heading */}
        <div className="text-center mb-10 md:mb-12">
          <p className="text-[11px] md:text-xs uppercase tracking-[0.25em] text-slate-400 mb-2">
            Partner Voices
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-slate-900 mb-3">
            Hear from Our Partners
          </h2>
          <p className="text-sm md:text-base text-slate-500 max-w-2xl mx-auto">
            Discover how our partnerships are shaping success stories across industries.
          </p>
        </div>

        {/* Cards */}
        <div className="grid gap-6 md:gap-7 lg:gap-8 md:grid-cols-3">
          {PARTNER_TESTIMONIALS.map((item) => (
            <TestimonialCard key={item.id} testimonial={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ testimonial }) {
  const { name, role, company, image, quote } = testimonial;

  return (
    <article className="relative flex flex-col rounded-[28px] bg-white border border-slate-100 shadow-[0_16px_40px_rgba(15,23,42,0.08)] px-6 pb-6 pt-10 md:px-7 md:pb-7 md:pt-11">
      {/* Avatar */}
      {/* <div className="absolute -top-10 left-1/2 -translate-x-1/2">
        <div className="relative h-20 w-20 rounded-full bg-white shadow-[0_10px_30px_rgba(15,23,42,0.24)] flex items-center justify-center">
          <div className="h-[70px] w-[70px] rounded-full overflow-hidden border-2 border-white">
            <img
              src={image}
              alt={name}
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </div> */}

      {/* Name / role */}
      <div className="mt-4 pt-2 text-center">
        <h3 className="text-sm md:text-base font-semibold text-slate-900">
          {name}
        </h3>
        <p className="mt-1 text-[11px] md:text-xs text-slate-500 leading-snug">
          {role}
          {company ? `, ${company}` : ""}
        </p>
      </div>

      {/* Quote icon */}
      <div className="mt-4 mb-3 flex justify-center">
        <div className="h-8 w-8 rounded-full bg-amber-100 flex items-center justify-center">
          <Quote className="h-4 w-4 text-[#f59f0b]" />
        </div>
      </div>

      {/* Text */}
      <p className="text-xs md:text-sm text-slate-600 leading-relaxed text-center">
        {quote}
      </p>
    </article>
  );
}
